import createLogger from '@cloudflare/util-logger';

var logError = createLogger('user-tracking:error');
var logWarn = createLogger('user-tracking:warn');
var logInfo = createLogger('user-tracking:info');

/*
  This is a simple wrapper around the Facebook Pixel Event API:
  https://developers.facebook.com/docs/ads-for-websites/pixel-events

  This wrapper is useful for:
    - Initializing the 'fbq' function on the client (no <script> needed)
    - Providing some safety around malformed events
*/

var standardEventNames = ['ViewContent', 'Search', 'AddToCart', 'AddToWishlist', 'InitiateCheckout', 'AddPaymentInfo', 'Purchase', 'Lead', 'CompleteRegistration'];

var _fbq = null;

export var initFBPixel = function initFBPixel(pixelId) {
  if (!pixelId) {
    logInfo('Facebook PixelID is not set. Refusing to initialize fbq');
    return;
  }

  /* Facebook Pixel Code */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(global, // changed from 'window' to 'global'
  document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* End Facebook Pixel Code */

  // Keep an internal reference to the newly created fbq
  _fbq = global.fbq;

  // Auto-configure
  _fbq('set', 'autoConfig', 'false', pixelId);
  _fbq('init', pixelId);
  logInfo('fbq initialized');
};

export var sendFBEvent = function sendFBEvent(eventName, customData) {
  if (!_fbq) {
    logError('fbq uninitialized. Please call "initFBPixel" before tracking');
    return;
  }

  if (!eventName) {
    logWarn('track expects an eventName!');
  }

  if (!standardEventNames.includes(eventName)) {
    logWarn('fbq standard events expect one of the following event names: ' + standardEventNames.join('\n'));
  }

  logInfo('fbq.track: ' + eventName + ' with data:\n ' + JSON.stringify(customData) + ' ');

  _fbq('track', eventName, customData);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/util-user-tracking/es/Facebook.js
// module id = 1080
// module chunks = 1